import { Helmet } from 'react-helmet';

/**
 * @description This components adds the panorama related scripts in the header of the app
 * @returns Helmet Element
 */
export const Panorama = () => {
  return (
    <Helmet>
      <script
        id="awsc-panorama-bundle"
        type="text/javascript"
        src="https://prod.pa.cdn.uis.awsstatic.com/panorama-nav-init.js"
        data-config='{
            "appEntity":"aws-console",
            "region":"us-west-2",
            "service":"personalize"
        }'
      ></script>
    </Helmet>
  );
};
